import { render, staticRenderFns } from "./Sell_task.vue?vue&type=template&id=36c7f576&scoped=true"
import script from "./Sell_task.vue?vue&type=script&lang=js"
export * from "./Sell_task.vue?vue&type=script&lang=js"
import style0 from "./Sell_task.vue?vue&type=style&index=0&id=36c7f576&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36c7f576",
  null
  
)

/* custom blocks */
import block0 from "./Sell_task.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports